/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export const draftPage = {
  pageHead: {
    municipality: {
      title: 'Kommunen',
      subtitle: 'Kontakt aufnehmen und Teil von {{appName}} werden.',
      description:
        'Wir freuen uns, dass du Teil von {{appName}} werden wollen! Nimm im ersten Schritt Kontakt zu uns auf, indem du das Kontaktformular ausfüllst und absendest.'
    },
    solutionProvider: {
      title: 'Lösungs<wbr>anbieter',
      subtitle: 'Kontakt aufnehmen und Teil von {{appName}} werden.',
      description:
        'Wir freuen uns, dass du Teil des Marktplatzes {{appName}} werden wollen! Nimm im ersten Schritt Kontakt zu uns auf, indem du das Kontaktformular ausfüllst und absendest.'
    },
    publicAuthorities: {
      title: 'Weitere öffentliche Aufgabenträger',
      subtitle: 'Kontakt aufnehmen und Teil von {{appName}} werden.',
      description:
        'Wir freuen uns, dass du Teil von {{appName}} werden wollen! Nimm im ersten Schritt Kontakt zu uns auf, indem du das Kontaktformular ausfüllst und absendest.'
    }
  },
  success: {
    title: 'Ihre Anfrage wurde erfolgreich gesendet!',
    content:
      'Vielen Dank\n Ihre Anfrage wird nun geprüft. Du erhältst in den nächsten Tagen eine E-Mail mit weiteren Informationen.',
    confirm: 'Alles Klar!'
  },
  name: {
    municipality: {
      label: 'Name der Kommune*',
      placeholder: 'Nach Kommune suchen',
      notFoundLabel: 'Kommune wurde nicht gefunden.',
      loadingLabel: 'Kommunen werden geladen.',
      minSearchLabel:
        'Bitte gebe mehr als zwei Zeichen ein, um die Suche zu starten',
      error:
        'Diese Kommune ist bereits registriert. Bei unklarer Zuständigkeit nutze bitte unser <0>Kontaktformular</0>.'
    },
    solutionProvider: {
      label: 'Name des Unternehmens*',
      placeholder: 'Name des Unternehmens',
      error:
        'Diese Unternehmen scheint bereits registriert zu sein. Bei unklarer Zuständigkeit nutze bitte unser <0>Kontaktformular</0>.'
    },
    publicAuthorities: {
      label: 'Name der Organisation*',
      placeholder: 'Name der Behörde, des Verbandes etc.',
      error:
        'Diese Organisation scheint bereits registriert zu sein. Bei unklarer Zuständigkeit nutze bitte unser <0>Kontaktformular</0>.'
    }
  },
  additionalInformation: {
    label: 'Organisationstyp*',
    placeholder: 'Bitte wählen'
  },
  solutionInformation: {
    label: 'Angebotene Lösung*',
    placeholder: 'Die Lösung, die auf dem Marktplatz angeboten werden soll'
  },
  website: {
    label: 'Webseite',
    placeholder: 'URL zu Ihrer Webseite'
  },
  contactPerson: {
    label: 'Name des Ansprechpartners*',
    placeholder: 'Vor- und Nachname des Ansprechpartners'
  },
  contactEmailAddress: {
    label: 'E-Mail-Adresse des Ansprechpartners*',
    info: {
      municipality:
        'Diese E-Mail wird für die Administration der Kommune eingeladen.',
      solutionProvider:
        'Diese E-Mail wird für die Administration der Lösungsanbieterorganisation eingeladen.',
      publicAuthorities:
        'Diese E-Mail wird für die Administration der Organisation eingeladen.'
    },
    placeholder: 'E-Mail-Adresse des Ansprechpartners'
  },
  memberEmailAddresses: {
    label: 'E-Mail weiterer Mitglieder',
    placeholder: 'E-Mail-Adressen weiterer Mitglieder',
    email: 'E-Mail-Adresse',
    add: 'E-Mail-Adresse hinzufügen',
    addMore: 'weitere E-Mail-Adresse hinzufügen',
    remove: 'E-Mail-Adresse entfernen'
  },
  formError: {
    name: {
      municipality: 'Bitte gib den Namen der Kommune ein.',
      solutionProvider: 'Bitte gib den Namen des Unternehmens ein.',
      publicAuthorities: 'Bitte gib den Namen der Organisation ein.'
    },
    contactEmailAddress: 'E-Mail ist ein Pflichtfeld.',
    invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse an.',
    contactPerson: 'Bitte gib den Namen des Ansprechpartners ein.',
    solutionInformation: 'Bitte mache Angaben zu der Angebotenen Lösung.',
    type: 'Bitte wähle einen Organisationstyp aus.',
    invalidWebsite: 'Bitte gib eine gültige URL an.'
  },
  send: 'Senden'
};
